"use client";

import { Button } from "@/components/ui/button";

interface ErrorProps {
  reset: () => void;
}

export const Error = ({ reset }: ErrorProps) => {
  return (
    <div className="flex flex-col gap-3 items-center justify-center min-h-[50vh] p-4">
      <h1 className="text-4xl font-bold text-center">Algo deu errado!</h1>
      <h2 className="text-center text-base text-muted-foreground max-w-md">
        Nosso time já foi avisado e estamos atuando para corrigir o problema.
        Tente novamente mais tarde.
      </h2>
      <div className="flex gap-2">
        <Button variant="outline" onClick={reset}>
          Atualizar página
        </Button>
      </div>
    </div>
  );
};
